import {AchievementContainer, AchievementInfo, Place, StyledAchievement} from "./Achievement.styles";
import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrophy} from "@fortawesome/free-solid-svg-icons";
import {MAIN_COLOR} from "../../../components/globalThemes";
import {formatDate} from "../../../helpers/helpersFunctions";

const Achievement = ({place, name, venue, date}) => {
    return (<StyledAchievement>
        <AchievementContainer>
            <FontAwesomeIcon icon={faTrophy} color={place === "1" ? 'gold' : place === "2" ? 'silver' : place === "3" ? '#cd7f32' : place === "3-4" ? '#cd7f32' : MAIN_COLOR}
                             style={{width: 50, height: 50}}>
            </FontAwesomeIcon>
            <Place>{place.charAt(0)}</Place>
        </AchievementContainer>
        <AchievementInfo color={'black'}>{name + ', ' + venue}</AchievementInfo>
        <AchievementInfo color={'grey'}>{formatDate(date, 'short')}</AchievementInfo>
    </StyledAchievement>)
};

export default Achievement;
